
<div class="AppNavigation" :class="{ 'is-collapsed': isCollapsed }" id="AppNavigation">
    <nav class="Wrapper">
        <template v-if="!isMobile">
            <div class="NavigationTop">
                <button
                    class="CollapseToggle"
                    @click="toggleNavigation"
                    :class="{ 'is-collapsed': isCollapsed }"
                >
                    <i class="ri-menu-line"></i>
                </button>

                <router-link v-if="!isCollapsed" to="/" class="Logo">
                    <img src="@/assets/svg/logo.svg" alt />
                </router-link>

                <template v-if="!isDataLoaded || !modules || modules.length === 0">
                    <div
                        v-for="i in 8"
                        :key="`nav-skeleton-${i}`"
                        class="Nav-Link Nav-Link-Skeleton"
                    >
                        <div class="SkeletonIcon"></div>
                        <div v-if="!isCollapsed" class="SkeletonText"></div>
                    </div>
                </template>

                <template v-else>
                    <NavLink
                        v-for="item in desktopNavItems"
                        :key="item.key"
                        :route="item.route"
                        :icon="item.icon"
                        :label="item.label"
                        :collapsed-label="item.collapsedLabel"
                        :tooltip="item.label"
                        :is-collapsed="isCollapsed"
                        @click="onNavClick"
                    />
                </template>

                <div
                    v-if="!hasMyPos && isDataLoaded && !isCollapsed"
                    class="mypos-promo-banner"
                >
                    <a @click.prevent="showMyPosModal = true" href="#" class="mypos-link">
                        <span>MyPos Go2 9€</span>
                        <i class="ri-bank-card-line"></i>
                    </a>
                </div>
            </div>

            <MyPosModal
                :show="showMyPosModal"
                :isLoading="false"
                @onClose="showMyPosModal = false"
            />

            <UpgradeModal :show="showUpgradeModal" @onClose="showUpgradeModal = false" />

            <div class="NavigationBottom">
                <div
                    v-if="
                        !isCollapsed && (availableAccounts.length > 0 || user?.customerNumber)
                    "
                    class="AccountInfo"
                >
                    <div v-if="user?.customerNumber" class="CustomerNumberDisplay">
                        <span class="CustomerNumberLabel">Kundennummer</span>
                        <span class="CustomerNumberValue">{{ user.customerNumber }}</span>
                    </div>
                    <div v-if="availableAccounts.length > 0" class="AccountSwitcher">
                        <select
                            v-model="selectedAccountCustomerNumber"
                            @change="handleAccountSwitchChange"
                            class="AccountSelect"
                            :disabled="isSwitchingAccount"
                        >
                            <option value="" disabled>Konto wechseln</option>
                            <option
                                v-for="account in availableAccounts"
                                :key="account.customerNumber"
                                :value="account.customerNumber"
                            >
                                {{ account.businessName }} ({{ account.customerNumber }})
                            </option>
                        </select>
                    </div>
                    <div v-if="isDevMode" class="DevAccountSwitcher">
                        <input
                            v-model="devCustomerNumber"
                            @keyup.enter="handleDevAccountSwitch"
                            class="DevAccountInput"
                            type="text"
                            inputmode="numeric"
                            placeholder="Kundennummer eingeben"
                            :disabled="isSwitchingAccount"
                        />
                        <button
                            @click="handleDevAccountSwitch"
                            class="DevAccountButton"
                            :disabled="isSwitchingAccount || !devCustomerNumber"
                        >
                            <i class="ri-arrow-right-line"></i>
                        </button>
                    </div>
                </div>
                <MenuDropdown
                    v-if="!isCollapsed"
                    title="Menu"
                    :items="menuItems"
                    :items-at-top="true"
                    :open-upward="true"
                    class="NavigationMenuDropdown theme-dark"
                >
                    <template #button-content="{ isOpen, openUpward }">
                        <div class="MenuTrigger-Content">
                            <div class="MenuTrigger-Info">
                                <div class="MenuTrigger-Name">{{ userName }}</div>
                                <div class="MenuTrigger-PlanRow">
                                    <div class="MenuTrigger-Plan">{{ planDisplayName }}</div>
                                    <button
                                        v-if="isPlanLite"
                                        class="MenuTrigger-UpgradeButton"
                                        @click.stop="showUpgradeModal = true"
                                    >
                                        Upgrade
                                    </button>
                                </div>
                            </div>
                            <i
                                :class="[
                                    openUpward ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line',
                                    { 'is-open': isOpen },
                                    'MenuTrigger-Arrow',
                                ]"
                            ></i>
                        </div>
                    </template>
                </MenuDropdown>
            </div>

            <NavigationIndicator
                v-if="!isCollapsed"
                :is-mobile="isMobile"
                :is-collapsed="isCollapsed"
                :drawer-routes="drawerRoutes"
                ref="navIndicator"
            />
            <HoverIndicator v-if="!isCollapsed" variant="default" ref="hoverIndicator" />
        </template>

        <template v-else>
            <div class="MobileNavBar">
                <NavLink
                    v-for="item in mobileBarItems"
                    :key="item.key"
                    :route="item.route"
                    :icon="item.icon"
                    :label="item.mobileBarLabel || item.label"
                    @click="onNavClick"
                />
                <button
                    class="Nav-Link More-Button"
                    :class="{
                        'router-link-exact-active': isCurrentRouteInDrawer,
                        'active-drawer-link': isCurrentRouteInDrawer,
                    }"
                    @click="openMoreDrawer"
                >
                    <i class="ri-more-2-fill"></i>
                    <span>Mehr</span>
                </button>
            </div>
            <MobileDrawer :is-visible="showMoreMenu" title="Mehr" @close="closeMoreDrawer">
                <div class="DrawerUserSection">
                    <MenuDropdown
                        :title="userName"
                        :items="mobileMenuItems"
                        class="MobileDrawerMenu theme-dark"
                    >
                        <template #button-content="{ isOpen, openUpward }">
                            <div class="MobileMenuTrigger-Content">
                                <div class="MobileMenuTrigger-Info">
                                    <div class="MobileMenuTrigger-Name">{{ userName }}</div>
                                    <div
                                        class="MobileMenuTrigger-Plan"
                                        v-if="user?.customerNumber"
                                    >
                                        Kundennummer: {{ user.customerNumber }}
                                    </div>
                                </div>
                                <i
                                    :class="[
                                        openUpward
                                            ? 'ri-arrow-up-s-line'
                                            : 'ri-arrow-down-s-line',
                                        { 'is-open': isOpen },
                                        'MobileMenuTrigger-Arrow',
                                    ]"
                                ></i>
                            </div>
                        </template>
                    </MenuDropdown>
                    <div v-if="availableAccounts.length > 0" class="DrawerAccountSwitcher">
                        <select
                            v-model="selectedAccountCustomerNumber"
                            @change="handleAccountSwitchChange"
                            class="DrawerAccountSelect"
                            :disabled="isSwitchingAccount"
                        >
                            <option value="" disabled>Konto wechseln</option>
                            <option
                                v-for="account in availableAccounts"
                                :key="account.customerNumber"
                                :value="account.customerNumber"
                            >
                                {{ account.businessName }} ({{ account.customerNumber }})
                            </option>
                        </select>
                    </div>
                    <div v-if="isDevMode" class="DrawerDevAccountSwitcher">
                        <input
                            v-model="devCustomerNumber"
                            @keyup.enter="handleDevAccountSwitch"
                            class="DrawerDevAccountInput"
                            type="text"
                            inputmode="numeric"
                            placeholder="Kundennummer eingeben (Dev)"
                            :disabled="isSwitchingAccount"
                        />
                        <button
                            @click="handleDevAccountSwitch"
                            class="DrawerDevAccountButton"
                            :disabled="isSwitchingAccount || !devCustomerNumber"
                        >
                            <i class="ri-arrow-right-line"></i>
                        </button>
                    </div>
                </div>
                <Button
                    v-for="item in mobileDrawerItems"
                    :key="item.key"
                    variant="plain"
                    class="DrawerNavButton"
                    @onClick="navigateAndClose(item.route)"
                >
                    <i :class="item.icon"></i>
                    {{ item.label }}
                </Button>
            </MobileDrawer>
            <NavigationIndicator
                :is-mobile="isMobile"
                :is-collapsed="isCollapsed"
                :drawer-routes="drawerRoutes"
                ref="mobileNavIndicator"
            />
            <HoverIndicator v-if="!isCollapsed" variant="default" ref="hoverIndicator" />
        </template>
    </nav>
</div>
